import { useEffect, useState } from "react";
import  {getDashboardParMois}  from "../../api/rendezVousService.api";

import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from "recharts";

const DashboardParMois = () => {
  const [data, setData] = useState([]);
   const [loading, setLoading] = useState(true);

  useEffect(() => {
     loadData();
  }, []);
const loadData = async () => {
    try {
      const res = await getDashboardParMois();
      setData(res.data);
      console.log(data);
      
    } catch (err) {
      console.error("Erreur chargement dashboard", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-graph">
      <h3>📅 Statistiques par mois</h3>

      <ResponsiveContainer width="100%" height={320}>
        <BarChart data={data}>
          <XAxis dataKey="mois" />
          <YAxis />
          <Tooltip />
          <Legend />

          <Bar dataKey="termine" name="Terminés" fill="#4caf50" />
          <Bar dataKey="en_cours" name="En cours" fill="#2196f3" />
          <Bar dataKey="en_attente" name="En attente" fill="#ff9800" />
        </BarChart>
      </ResponsiveContainer>

      
    </div>
  );
};

export default DashboardParMois;
